<template>
  <div class="lander">

    <h1 style="position: fixed; top: -100px; color: transparent; z-index: 0; height: 0">Your Dashboard</h1>
    <div style="position: fixed; top: -100px; color: transparent; z-index: 0; height: 0">Your personalized hub to track vehicles, recommendations, market insights, and alerts all in one place.</div>

    <LiveMarketTicker
      style="position: absolute;
 top: 0;
  left: 0;
  z-index: 1;"
    />

    <div style="margin-top: 36px; margin-bottom: 32px">
      <SearchInputBar
          v-if="enableMobileDisplay"
          style="width: 100%;"
      />
    </div>

    <div
      class="q-mt-md q-mb-xl"
      :class="{
        'flex items-center justify-between no-wrap': !enableMobileDisplay,
        column: enableMobileDisplay
      }"
    >
      <div>
        <h2 class="q-mb-xs" data-nosnipper>{{ greetingHeader }}</h2>
        <div v-if="totalVehiclesLoading">
          <q-skeleton
            type="rect"
            width="200%"
            animation="fade"
            class="q-mt-sm"
          />
        </div>
        <div v-else class="--text-lg text-text-light" data-nosnippet>
          {{
            returningVisitor
              ? "While you were away we analyzed"
              : "CarScience is analyzing"
          }}
          {{ formatNumber(totalVehicles, true, 1) }}
          listings to find the best matches for you.
        </div>
        <div style="display: none">CarScience provides personalized recommendations, and market insights, on millions of vehicles to simplify your search. Experience a new, personalized way to shop for your next vehicle. This is car shopping, catered to you.</div>
      </div>
      <q-btn
        v-if="!enableMobileDisplay"
        label="Customize Dashboard"
        no-caps
        icon="sym_r_dashboard_customize"
        class="--bordered"
        :color="!enableMobileDisplay ? 'secondary' : 'background-light'"
        @click="() => (showCustomizeDashboardPanel = true)"
        :class="{ 'q-mt-md': enableMobileDisplay }"
      />
    </div>

    <div class="lander-content-container" :style="[activeWidgets.length > 0 ? { 'grid-template-columns': '1fr 360px' } : { 'grid-template-columns': '1fr' }]">
      <div class="lander__left-content">
        <RecommendedSearchesWidget
          v-if="isRecommendedSearchesEnabled"
          style="margin-top: -12px; margin-bottom: 84px; width: 100%;"
        />
        <!-- Vehicle Listings Sections -->
        <div class="listings-container q-gutter-y-xl">
          <component
            v-for="section in activeSections"
            :key="section.id"
            :is="section.component || 'VehicleListingsBase'"
            :title="section.name"
            :horizontal-scrollable="section.horizontalScrollable !== false"
            :filters="section.filters || []"
            :scoring="section.scoring || []"
            :options="
              section.options || {
                location_search: {
                  postal_code: $store.state.search.location.postalCode || '',
                  radius: $store.state.search.location.radius || 100,
                  include_distance_field: true
                }
              }
            "
            :sorting="section.sorting || [{ _score: 'desc' }]"
            :enable-vehicle-count="section.enableVehicleCount !== false"
            :tracking-id="section.id"
            :enable-view-all="section.enableViewAll !== false"
            hide-on-empty
          />
        </div>
      </div>
      <div v-show="activeWidgets.length > 0" class="lander__right-content">
        <div
          class="widgets-container"
          :class="{
            'q-gutter-y-md': !enableMobileDisplay,
            'q-gutter-lg q-mt-lg': enableMobileDisplay
          }"
        >
          <component
            v-for="widget in activeWidgets"
            :key="widget.id"
            :is="getWidgetComponent(widget.id)"
          />
        </div>
      </div>
    </div>

    <q-dialog
      v-model="showCustomizeDashboardPanel"
      v-cloak
      position="right"
      full-height
    >
      <q-card class="customize-dashboard-panel">
        <DialogHeader
          header="Customize Your Dashboard"
          class="no-shadow bg-background"
          style="border-top-left-radius: 0 !important;border-top-right-radius: 0 !important; position: sticky; top: 0; z-index: 1;"
        />
        <q-card-section class="q-mt-sm">
          <div class="q-gutter-y-md">
            <div
              class="section-control-item cursor-pointer"
              @click.stop.prevent="
                () => {
                  toggleRecommendedSearches();
                }
              "
            >
              <div class="flex items-center">
                <q-checkbox
                  :model-value="isRecommendedSearchesEnabled"
                  @update:model-value="
                    val => {
                      toggleRecommendedSearches(val);
                    }
                  "
                  class="q-mr-xs"
                  color="secondary"
                  size="lg"
                />
                <div>
                  <div class="flex-1 text-weight-medium">
                    Search Suggestions For You
                  </div>
                  <div class="text-text-light">
                    A smart list of searches suggestions catered to you.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </q-card-section>
        <q-card-section class="q-pt-sm">
          <div class="q-gutter-y-md">
            <div>
              <div class="--text-lg text-weight-medium q-mb-none">
                Your Listings
              </div>
              <div class=" text-text-light q-mb-md">
                Choose the vehicle listings sections that appear on your
                dashboard.
              </div>
            </div>

            <draggable
              v-model="vehicleListingsSections"
              item-key="id"
              handle=".drag-handle"
              @end="saveDashboardSettings"
              class="cursor-pointer"
            >
              <template #item="{ element }">
                <div
                  class="section-control-item q-mb-sm"
                  @click.stop.prevent="
                    () => {
                      toggleSection(element.id);
                    }
                  "
                >
                  <div class="flex items-center">
                    <q-icon
                      name="sym_r_drag_indicator"
                      size="23px"
                      class="drag-handle cursor-grab"
                    />
                    <q-checkbox
                      :model-value="element.enabled"
                      @update:model-value="
                        val => toggleSection(element.id, val)
                      "
                      class="q-mr-xs"
                      color="secondary"
                      size="lg"
                    />
                    <div>
                      <div class="flex-1 text-weight-medium">
                        {{ element.name }}
                      </div>
                      <div class="text-text-light">
                        {{ element.blurb }}
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </draggable>
          </div>
        </q-card-section>
        <q-card-section class="q-pt-sm">
          <div class="q-gutter-y-md">
            <div>
              <div class="--text-lg text-weight-medium">
                Your Widgets
              </div>
              <div class="text-text-light q-mb-md">
                Choose the widgets that appear on the right side of your
                dashboard.
              </div>
            </div>

            <draggable
              v-model="dashboardWidgets"
              item-key="id"
              handle=".drag-handle"
              @end="saveWidgetSettings"
              class="cursor-pointer"
            >
              <template #item="{ element }">
                <div
                  class="section-control-item q-mb-sm"
                  @click.stop.prevent="
                    () => {
                      toggleWidget(element.id);
                    }
                  "
                >
                  <div class="flex items-center">
                    <q-icon
                      name="sym_r_drag_indicator"
                      size="23px"
                      class="drag-handle cursor-grab"
                    />
                    <q-checkbox
                      :model-value="element.enabled"
                      @update:model-value="val => toggleWidget(element.id, val)"
                      class="q-mr-xs"
                      color="secondary"
                      size="lg"
                    />
                    <div>
                      <div class="flex-1 text-weight-medium">
                        {{ element.name }}
                      </div>
                      <div class="text-text-light">
                        {{ element.blurb }}
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </draggable>
          </div>
        </q-card-section>

        <q-card-actions
          class="--border-top bg-background-light --shadow__top"
          style="position: fixed; bottom: 0; width: 100%; z-index: 1;"
        >
          <q-btn
            label="Reset to Defaults"
            flat
            no-caps
            color="text-light"
            @click="resetDashboardSettings"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { defineAsyncComponent } from "vue";
import VehicleListingsBase from "@/components/VehicleListings/VehicleListingsBase.vue";
import DialogHeader from "@/components/UI/DialogHeader.vue";
import draggable from "vuedraggable";
import MarketPulseWidget from "@/components/Widgets/MarketPulseWidget.vue";
import DealScoreDistributionWidget from "@/components/Widgets/DealScoreDistributionWidget.vue";
import MarketVelocityWidget from "@/components/Widgets/MarketVelocityWidget.vue";
import PopularModelsWidget from "@/components/Widgets/PopularModelsWidget.vue";
import LocalMarketPulseWidget from "@/components/Widgets/LocalMarketPulseWidget.vue";
import RecommendedSearchesWidget from "@/components/Widgets/RecommendedSearchesWidget.vue";
import SearchInputBar from "@/components/SearchInputBar.vue";
import LiveMarketTicker from "@/components/LiveMarketTicker.vue";

const DASHBOARD_SETTINGS_KEY = "dashboard-sections-settings";
const DASHBOARD_WIDGETS_KEY = "dashboard-widgets-settings";

const DEFAULT_SECTIONS = [
  {
    id: "best-matches",
    name: "Best Matches For You",
    component: "VehicleListingsBestMatches",
    blurb: "Vehicles recommended for you.",
    enabled: true,
    enableViewAll: true,
    enableVehicleCount: true
  },
  {
    id: "best-deals",
    name: "Best Deals",
    component: "VehicleListingsBestDeals",
    blurb: "Vehicles with the best deals.",
    enabled: true,
    enableViewAll: true,
    enableVehicleCount: true
  },
  {
    id: "custom-phrases",
    name: "Smart Searches",
    component: "VehicleListingsCustomPhrasesTrio",
    blurb: "Displays three smart vehicle sections tailored to your interests.",
    enabled: true,
    enableViewAll: true,
    enableVehicleCount: true
  },
  {
    id: "recent-price-drops",
    name: "Recent Price Drops",
    component: "VehicleListingsRecentPriceDrops",
    blurb: "Vehicles with recent price drops.",
    enabled: true,
    enableViewAll: true,
    enableVehicleCount: true
  },
  {
    id: "newly-added",
    name: "Newly Added",
    component: "VehicleListingsNewlyAdded",
    blurb: "Vehicles that are newly listed.",
    enabled: true,
    enableViewAll: true,
    enableVehicleCount: true
  }
];

const DEFAULT_WIDGETS = [
  {
    id: "market-pulse",
    name: "Market Pulse",
    blurb: "A real-time snapshot of the market.",
    enabled: true
  },
  {
    id: "local-market-pulse",
    name: "Local Market Comparison",
    blurb: "Compare your region to the nationwide market.",
    enabled: true
  },
  {
    id: "inventory-velocity",
    name: "Inventory Velocity",
    blurb: "How often the market is changing.",
    enabled: true
  },
  {
    id: "popular-models",
    name: "Popular Models",
    blurb: "The most listed makes on the market.",
    enabled: true
  },
  {
    id: "deal-distribution",
    name: "Deals Distribution",
    blurb: "How deals are spread across the market.",
    enabled: true
  }
];

export default {
  name: "Lander",
  components: {
    SearchInputBar,
    DialogHeader,
    VehicleListingsBase,
    // Specialized listing components loaded async
    VehicleListingsRecentPriceDrops: defineAsyncComponent(() =>
      import("@/components/VehicleListings/VehicleListingsRecentPriceDrops.vue")
    ),
    VehicleListingsNewlyAdded: defineAsyncComponent(() =>
      import("@/components/VehicleListings/VehicleListingsNewlyAdded.vue")
    ),
    VehicleListingsBestMatches: defineAsyncComponent(() =>
      import("@/components/VehicleListings/VehicleListingsBestMatches.vue")
    ),
    VehicleListingsBestDeals: defineAsyncComponent(() =>
      import("@/components/VehicleListings/VehicleListingsBestDeals.vue")
    ),
    VehicleListingsCustomPhrasesTrio: defineAsyncComponent(() =>
      import(
        "@/components/VehicleListings/VehicleListingsCustomPhrasesTrio.vue"
      )
    ),
    draggable,
    MarketPulseWidget,
    DealScoreDistributionWidget,
    MarketVelocityWidget,
    PopularModelsWidget,
    LocalMarketPulseWidget,
    RecommendedSearchesWidget,
    LiveMarketTicker
  },
  data() {
    return {
      totalVehicles: 1500000,
      totalVehiclesLoading: true,
      greetingHeader: "",
      showCustomizeDashboardPanel: false,
      vehicleListingsSections: [],
      dashboardWidgets: [],
      showRecommendedSearches: true
    };
  },
  computed: {
    activeSections() {
      return this.vehicleListingsSections.filter(section => section.enabled);
    },
    activeWidgets() {
      return this.dashboardWidgets.filter(widget => widget.enabled);
    },
    isRecommendedSearchesEnabled() {
      return this.showRecommendedSearches;
    },
    returningVisitor() {
      return this.$store.getters["returningVisitor"];
    }
  },
  beforeUnmount() {},
  mounted() {
    this.$store.commit("search/SET_SEARCH_FILTERS", []);
    this.$store.commit("search/RESET_PAGINATION");

    this.loadDashboardSettings();
    this.loadWidgetSettings();
    this.loadRecommendedSearchesSetting();
    this.generateGreetingHeader();
    this.initTotalVehicles();

    window.localStorage.setItem("last-carscience-session-id", this.$store.state.sessionId);
  },
  methods: {
    loadDashboardSettings() {
      const savedSettings = localStorage.getItem(DASHBOARD_SETTINGS_KEY);

      if (savedSettings) {
        try {
          const parsed = JSON.parse(savedSettings);
          // Merge saved settings with defaults to handle new sections
          this.vehicleListingsSections = DEFAULT_SECTIONS.map(
            defaultSection => {
              const saved = parsed.find(s => s.id === defaultSection.id);
              return saved ? { ...defaultSection, ...saved } : defaultSection;
            }
          );
        } catch (e) {
          console.error("Failed to parse dashboard settings:", e);
          this.vehicleListingsSections = [...DEFAULT_SECTIONS];
        }
      } else {
        this.vehicleListingsSections = [...DEFAULT_SECTIONS];
      }
    },
    saveDashboardSettings() {
      const settings = this.vehicleListingsSections.map(section => ({
        id: section.id,
        enabled: section.enabled
      }));
      localStorage.setItem(DASHBOARD_SETTINGS_KEY, JSON.stringify(settings));
    },
    toggleSection(sectionId, enabled = null) {
      const section = this.vehicleListingsSections.find(
        s => s.id === sectionId
      );
      if (section) {
        if (enabled === null) {
          section.enabled = !section.enabled;
        } else {
          section.enabled = enabled;
        }
        this.saveDashboardSettings();
      }
    },
    resetDashboardSettings() {
      this.vehicleListingsSections = JSON.parse(
        JSON.stringify(DEFAULT_SECTIONS)
      );
      this.dashboardWidgets = JSON.parse(JSON.stringify(DEFAULT_WIDGETS));
      this.showRecommendedSearches = true;
      localStorage.removeItem(DASHBOARD_SETTINGS_KEY);
      localStorage.removeItem(DASHBOARD_WIDGETS_KEY);
      localStorage.removeItem("show-recommended-searches");
    },
    loadRecommendedSearchesSetting() {
      const saved = localStorage.getItem("show-recommended-searches");
      if (saved !== null) {
        this.showRecommendedSearches = saved === "true";
      }
    },
    toggleRecommendedSearches(enabled = null) {
      if (enabled === null) {
        this.showRecommendedSearches = !this.showRecommendedSearches;
      } else {
        this.showRecommendedSearches = enabled;
      }
      localStorage.setItem(
        "show-recommended-searches",
        this.showRecommendedSearches.toString()
      );
    },
    loadWidgetSettings() {
      const savedSettings = localStorage.getItem(DASHBOARD_WIDGETS_KEY);

      if (savedSettings) {
        try {
          const parsed = JSON.parse(savedSettings);
          this.dashboardWidgets = DEFAULT_WIDGETS.map(defaultWidget => {
            const saved = parsed.find(w => w.id === defaultWidget.id);
            return saved ? { ...defaultWidget, ...saved } : defaultWidget;
          }).sort((a, b) => (a.order ?? 999) - (b.order ?? 999));
        } catch (e) {
          console.error("Failed to parse widget settings:", e);
          this.dashboardWidgets = [...DEFAULT_WIDGETS];
        }
      } else {
        this.dashboardWidgets = [...DEFAULT_WIDGETS];
      }
    },
    saveWidgetSettings() {
      const settings = this.dashboardWidgets.map((widget, index) => ({
        id: widget.id,
        enabled: widget.enabled,
        order: index
      }));
      localStorage.setItem(DASHBOARD_WIDGETS_KEY, JSON.stringify(settings));
    },
    toggleWidget(widgetId, enabled = null) {
      const widget = this.dashboardWidgets.find(w => w.id === widgetId);
      if (widget) {
        if (enabled === null) {
          widget.enabled = !widget.enabled;
        } else {
          widget.enabled = enabled;
        }
        this.saveWidgetSettings();
      }
    },
    isWidgetEnabled(widgetId) {
      const widget = this.dashboardWidgets.find(w => w.id === widgetId);
      return widget ? widget.enabled : false;
    },
    getWidgetComponent(widgetId) {
      const componentMap = {
        "market-pulse": "MarketPulseWidget",
        "local-market-pulse": "LocalMarketPulseWidget",
        "deal-distribution": "DealScoreDistributionWidget",
        "inventory-velocity": "MarketVelocityWidget",
        "popular-models": "PopularModelsWidget"
      };
      return componentMap[widgetId];
    },
    generateGreetingHeader() {
      let greetingHeader = this.getTimeOfDayGreeting();

      if (this.returningVisitor) {
        greetingHeader = "Welcome Back";
      }

      let leadFormUserData = window.localStorage.getItem(
        window.location.hostname + "-leadFormUserData"
      );
      if (leadFormUserData) {
        leadFormUserData = JSON.parse(leadFormUserData);
        greetingHeader += ", " + leadFormUserData.firstName;
      }
      greetingHeader += "!";

      this.greetingHeader = greetingHeader;
    },
    initTotalVehicles() {
      axios
        .post(
          "https://api-v2.jumpfeed.com/network/publisher/products/vehicles",
          {
            pagination: {
              page: 1,
              per_page: 1
            }
          }
        )
        .then(response => {
          this.totalVehicles = response.data.data.totals.results;
        })
        .finally(() => {
          this.totalVehiclesLoading = false;
        });
    }
  }
};
</script>

<style scoped lang="scss">
.lander {
  @include full-screen-height;
  background: color(background);
  padding: $space-lg;
  padding-top: 30px;

  @include screen-sm {
    padding: $space-md;
  }

  .lander-content-container {
    display: grid;
    grid-template-rows: repeat(1, 1fr);
    gap: 24px;

    @include screen-md {
      grid-template-columns: 1fr !important;
    }

    .lander__left-content,
    .lander__right-content {
      min-width: 0;
    }

    .lander__right-content {
      margin-top: -16px;
    }
  }
}

.customize-dashboard-panel {
  position: relative;
  width: 80vw;
  max-width: 600px !important;
  border-radius: 0 !important;
  border-top: 0;
  background: color(background, light);
  height: 100dvh;
  padding-bottom: 64px;

  .section-control-item {
    padding: 10px 12px;
    background: color(background, very-light);
    border-radius: $border-radius;
    transition: all 0.2s ease;

    &:hover {
      background: color(background, very-very-light);
    }

    .drag-handle {
      cursor: grab;
      color: color(text, light);

      &:active {
        cursor: grabbing;
      }
    }
  }
}
</style>
<style lang="scss">
.customize-dashboard-panel {
  .q-checkbox__bg {
    border-radius: 7px;
    border-width: 3px;
  }
}
</style>
